export default __webpack_public_path__ + "static/media/cesto_carote.88d54d91.svg";